




















import i18n from "../i18n";
import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GTopicSubject from '@/components/GTopicSubject.vue';
import GLoading from '@/components/GLoading.vue';

@Component({
  components: { GLoading, GTopicSubject },
  computed: {},
  methods: {},
})
export default class GTemplateTopicForm extends mixins(GPageBase) {
  isTimer: boolean = true;
  timer: number;

  @Prop() isShowContentCondition: boolean;
  @Prop({ default: i18n.t('NOTICE_DATA_NOT_LOAD') })
  errorText: string;

  mounted() {
    this.startTimer();
  }

  startTimer() {
    this.isTimer = true;
    const self: any = this;
    clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      self.isTimer = false;
    }, 30000);
  }
}
